export const Conexion = {
    MetodoBackOffice: 'BackOfficeNotificacion',
    AddBackOffice: 'AddBackOffice',
    AddBackOfficeORG: 'AddOrganizacionBackOffice'
};
